export const educationData = [
  {
    id: 1,
    institution: "Masai School",
    course: "Full Stack Web Development",
    startYear: "2021",
    endYear: "2022",
  },
  {
    id: 2,
    institution: " Sri Venkateshware Degree College",
    course: "Bachelor of Science",
    startYear: "2019",
    endYear: "2022",
  },
];
 